// BOOTSTRAP
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Modal from 'bootstrap/js/dist/modal'; 

// GSAP
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

let gsapSmoothScrollObj;
function gsapInitScrollSmoother() {
  if ( ScrollTrigger.isTouch != 1) {
    gsapSmoothScrollObj =  ScrollSmoother.create({
      smooth: 0.8,
      effects: true,
    });
  };
};
window.addEventListener("DOMContentLoaded", () => {
  gsapInitScrollSmoother(); 
});

export { gsap };
export { ScrollSmoother };
export { ScrollTrigger };
export { gsapSmoothScrollObj };

// NAVBAR STICKY
var topNav = document.querySelector('.top-navbar');
var nav = document.querySelector('.navbar-custom');

nav.style.top = topNav.offsetHeight + "px";
window.onscroll = function () {
  if (window.pageYOffset > (nav.offsetHeight - topNav.offsetHeight)) {
    nav.style.top = "0px";
  } else {
    nav.style.top = topNav.offsetHeight + "px";
  }
}

// NAVBAR DROPDOWN
const menuLang = document.querySelectorAll('.navbar-custom .pll-parent-menu-item');
const subMenu = document.querySelectorAll('.pll-parent-menu-item .sub-menu');

for (const lang of menuLang) {
  for (const dropdown of subMenu) {
    if (window.innerWidth > 991) {
    	lang.addEventListener('mouseenter', () => {
        dropdown.style.display = "block";
    	})
    	lang.addEventListener('mouseleave', () => {
        dropdown.style.display = "none";
    	})
    }
  }
}

// POLYLANG MOBILE
if (window.innerWidth <= 991) {
  document.querySelector('.lang-mobile').onclick = function() {
    document.querySelector('.lang-mobile .sub-menu').classList.toggle('shown');
  }

  document.querySelector('.lang-offcanvas').onclick = function() {
    document.querySelector('.lang-offcanvas .sub-menu').classList.toggle('shown');
  }
}

// BACK TO TOP
jQuery(function($){
  var btn = $(".back-to-top");
  $(window).scroll(function () {
    if ($(window).scrollTop() > 500) {
      btn.addClass("show");
    } else {
      btn.removeClass("show");
    }
  });

  btn.on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 100);
  });
});

// GSAP ANIMATION FADE UP
function fadeUpOnScroll() {
  const fadeUpEl = document.querySelectorAll('.fade-up');
  fadeUpEl.forEach((item) => {
    gsap.fromTo(item, {
        y: 100,
        autoAlpha: 0,
    }, {
        y: 0,
        autoAlpha: 1,
        duration: 0.8,
        ease: "ease",
        scrollTrigger: {
            trigger: item,
            start: "top-=100px bottom-=15%",
            // markers: true,
        },
    })
  })
}
window.addEventListener("DOMContentLoaded", () => {
  fadeUpOnScroll();
});

// PRELOADER
window.addEventListener("DOMContentLoaded", () => {
  const preloader = document.querySelector('.preloader');
  preloader.style.display = "none";
})